export const getSourceTestConnectionResult = 'getSourceTestConnectionResult';
export const isSourceTestConnectionResultSuccessful =
  'isSourceTestConnectionResultSuccessful';
